export default {
  GET_BRANCHES: ({ page = 1, rowsPerPage = 10 }) => `core/locations/?page=${page}&page_size=${rowsPerPage}`,
  GET_AUDIT_BRANCHES: 'core/locations',
  CREATE_BRANCH: 'core/locations/',
  UPDATE_BRANCH: (id) => `core/locations/${id}/`,
  DELETE_BRANCH: (id) => `core/locations/${id}/`,
};
